import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ResponseService } from '../services/response/response.service';
import { Injectable } from '@angular/core';
import { CommunicationService } from '../services/communication.service';

@Injectable()
export class SetRouteCodeGuard implements CanActivate {
  constructor(private responseService: ResponseService,
    private communicationService: CommunicationService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    const routeCode = route.data ? route.data.routeCode : null;

    this.responseService.setRouteCode(routeCode);
    this.communicationService.activeRouteCode.next(route.data && route.data.routeCode ? route.data.routeCode : null);
    return true;
  }
}
